module.exports = function getResource(label, vars = []) {
    let resources = {
        kilometer: 'kilomètre',
        mile: 'mille',
        away: 'absent',
        closed: 'Fermé',
        storeClosed: 'Store Closed',
        openUntil: `Ouvert jusqu’à ${vars[0]}`,
        getDirections: 'Obtenir l’itinéraire'
    };

    return resources[label];
};
